import { Provider } from '@angular/core';
import { AoSearchService } from 'src/app/services/ao-search-service/ao-search.service';
import { AOVideosService, AO_VIDEOS_SERVICE_CONFIG } from 'src/app/services/ao-videos.service';
import { ContextConfigInterface, ContextEnvironmentConfigInterface } from 'src/config/config.model';

export type ContextConfigType =  ContextConfigInterface & ContextEnvironmentConfigInterface;

export function getCommonProviders(contextConfig: ContextConfigType): Array<Provider> {
  return [
    AoSearchService,
    AOVideosService,
    {
      provide: AO_VIDEOS_SERVICE_CONFIG,
      useValue: {
        context: contextConfig.key,
        kaltura: contextConfig.kaltura
      }
    }
  ];
}
